import { useMutation } from "@apollo/client";
import { useTranslations } from "use-intl";
import { useNotification } from "@/shared/feedback/notification";
import { SEND_POST_TO_MODERATION } from "../api/send-post-to-moderation";
import { GET_MY_POSTS } from "@/modules/feed/widgets/my-posts/api/get-my-posts";
import { GET_POSTS_FOR_MODERATION } from "@/modules/feed/widgets/posts-moderation/api/get-posts-for-moderation";

/**
 * Без этого шага пост в ленту не попадёт никогда: savePost оставляет его черновиком.
 */
export function useSendPostToModeration() {
  const t = useTranslations("Post");
  const notify = useNotification();
  const [send, { loading }] = useMutation(SEND_POST_TO_MODERATION, {
    refetchQueries: [GET_MY_POSTS, GET_POSTS_FOR_MODERATION],
    awaitRefetchQueries: true,
  });

  const sendToModeration = async (postId: string) => {
    const { data } = await send({ variables: { postId } });

    if (data?.sendPostToModeration) {
      notify?.success({ message: t("Post sent to moderation") });
    }

    return data?.sendPostToModeration;
  };

  return { sendToModeration, loading };
}
